<template>
    <div class="step-progressbar">
        <div v-for="(step, index) in steps" :key="index" :class="stepItemClass(index)">
            <div :class="counterClass(index)" @click="goToStep(index)">{{ index + 1 }}</div>
            <div class="step-progressbar__step">{{ step }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            steps: { type: Array, required: true },
            currentStep: { type: Number, default: 0 },
            isClickable: { type: Boolean, default: false },
        },

        methods: {
            counterClass(index) {
                return {
                    'step-progressbar__counter': true,
                    'step-progressbar__counter--clickable': this.isClickable,
                    'step-progressbar__counter--active': this.currentStep === index,
                }
            },

            stepItemClass(index) {
                return {
                    'step-progressbar__item': true,
                    'step-progressbar__item--active': this.currentStep === index,
                    'step-progressbar__item--completed': this.currentStep > index,
                }
            },

            goToStep(step) {
                if (this.isClickable) {
                    this.emitEvent({ name: 'go-to-step', payload: step })
                }
            },
        },
    }
</script>
